import { PdfViewerComponent } from "@syncfusion/ej2-react-pdfviewer";

const getImageSize = (base64Img: string) => {
    return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
            resolve({
                width: img.width,
                height: img.height
            });
        };

        img.onerror = reject;
        img.src = base64Img;
    });
}

const calculateRatio = async (pdfViewer: PdfViewerComponent, page: number, base64Img: string) => {
    if(pdfViewer && page <= pdfViewer.pageCount) {
        const viewerPageSize = pdfViewer.viewerBase.pageSize[page];
        const imageSize: any = await getImageSize(base64Img);

        return imageSize.width / viewerPageSize.width;
    } else {
        return 0;
    }
}

export {
    getImageSize,
    calculateRatio
}